const accessLevels = [["Admin"], ["Owner"], ["Guest", "Agent"]];
let agentRoles = { Admin: 0 };

class RolesHelper {
    isAgent() {
        const agent = window.sessionStorage.getItem("agent");
        if (agent) {
            return true;
        }
        return false;
    }
    isAdmin() {
        return this.hasAccessLevel(0);
    }

    isOwner() {
        return this.hasAccessLevel(1);
    }

    isGuest() {
        return this.hasAccessLevel(2);
    }

    hasAccessLevel(level) {
        for (let a = 0; a <= level; a++) {
            for (let i = 0; i < accessLevels[a].length; i++) {
                if (this.hasRole(accessLevels[a][i])) {
                    return true;
                }
            }
        }
        return false;
    }

    hasRole(role) {
        try {
            let roles = window.sessionStorage.getItem("roles");

            if (roles) {
                const roleList = JSON.parse(roles);
                for (let i = 0; i < roleList.length; i++) {
                    if (roleList[i] == role) {
                        return true;
                    }
                }
            }

            return false;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    hasAgentAccess(level, exact) {
        if (Object.keys(agentRoles).length <= 1) {
            try {
                const agentUserGroups = window.agentPortal.userGroups;
                for (let i = 0; i < agentUserGroups.length; i++) {
                    const group = agentUserGroups[i];
                    agentRoles[group.role] = group.accessLevel;
                }
            } catch (e) {}
        }

        let roles = window.sessionStorage.getItem("roles");

        if (roles) {
            roles = JSON.parse(roles);

            let viableRoles = [];
            const accessKeys = Object.keys(agentRoles);
            for (let i = 0; i < accessKeys.length; i++) {
                const role = agentRoles[accessKeys[i]];
                if (exact) {
                    if (role == level || role == 0) {
                        viableRoles.push(accessKeys[i]);
                    }
                } else {
                    if (role <= level || role == 0) {
                        viableRoles.push(accessKeys[i]);
                    }
                }
            }

            for (let i = 0; i < roles.length; i++) {
                const role = roles[i];
                for (let a = 0; a < viableRoles.length; a++) {
                    const viableRole = viableRoles[a];
                    if (role == viableRole) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    filterAccess(resourceList) {
        try {
            let userRoles = window.sessionStorage.getItem("roles");
            userRoles = userRoles ? JSON.parse(userRoles) : [];
            userRoles = Array.isArray(userRoles) ? userRoles : [userRoles];

            if (userRoles.some((role) => role.toUpperCase() === "ADMIN")) {
                // Admin role has all access always.
                return resourceList;
            }

            let filteredResourceList = [];

            for (let i = 0; i < resourceList.length; i++) {
                let resource = resourceList[i];
                let hasAccess = true;

                if (resource && resource.accessRoles) {
                    // Access is based on whether the user shares a role with the resource.
                    hasAccess = userRoles.some((role) =>
                        resource.accessRoles.includes(role.toUpperCase())
                    );
                }

                if (hasAccess) {
                    filteredResourceList.push(resource);
                }
            }

            return filteredResourceList;
        } catch (e) {
            console.log(e);
            return [];
        }
    }
}

export default new RolesHelper();
